import { useTransitionEffect } from '@magic/ui/hooks/use-transition-effect';

import { useChannel } from './channel';
import { useChat } from './context/chat';

export const Events = () => {
  const channel = useChannel();
  const { lead } = useChat();

  useTransitionEffect(
    (lead) => {
      if (lead) {
        channel?.emit('onLeadCaptured', lead);
      }
    },
    lead,
    undefined
  );

  return null;
};
